export const preferenceCenter = () => {
    const checkEmailForm = document.querySelector('#lsf__preference-center__email-form');

    if ( checkEmailForm ) {
        const submitButton = checkEmailForm.querySelector('.js__preference-center-confirm-email__submit');

        submitButton.addEventListener('click', (e) => {
            e.preventDefault();

            const emailField = checkEmailForm.querySelector('#lsf__preference-center-confirm-email');
            const errorField = checkEmailForm.querySelector('.lsf__preference-center__email-form-error');
        
            // Reset error field
            emailField.classList.remove('error');
            errorField.classList.add('d-none');
        
            if ( !emailField.value ) {
                emailField.classList.add('error');
                errorField.classList.remove('d-none');
                return;
            }
        
            // Add loading class
            const emailFormContainer = checkEmailForm.closest('.lsf__preference-center__email-form-container');
            emailFormContainer.classList.add('loading');            

            const formData = new FormData(checkEmailForm);
            formData.append('action', 'emma_check_email');
            formData.append('security', igniteJsVars.nonce);
        
            fetch(igniteJsVars.ajaxurl, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            })
                .then((response) => response.text())
                .then((data) => {
                    const response = JSON.parse(data);
                    console.log(response);
                    console.log(response.data.status);

                    const userData = {
                        email: response.data.email,
                        status: response.data.status,
                    };

                    if (response.data.sms && response.data.sms.phone_number) {
                        userData.sms = response.data.sms.phone_number;
                    } 

                    Object.entries(response.data.fields).forEach(([name, value]) => {
                         // Check if the value is a date in the @D: format
                        if (typeof value === 'string' && value.startsWith('@D:')) {
                            // Extract just the date part
                            //value = value.substring(3);
                        }
                        userData[name] = value;
                    });

                    if ( response.status === 'success' ) {
                        getPreferenceFields(userData);
                    } else {
                        console.log('error');
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        });
    }

    // Add event delegation for the submit button
    document.addEventListener('click', (event) => {
        if (event.target.matches('.lsf__preference-center__preferences-form-submit')) {
            handlePreferencesFormSubmit(event);
        }
    });

    // Add event listener directly to the accept message button
    const acceptMessageButton = document.querySelector('.js-accept-message');
    if (acceptMessageButton) {
        acceptMessageButton.addEventListener('click', hideMessageContainer);
    }
}

const getPreferenceFields = (userData) => {
    const formData = new FormData();
    formData.append('action', 'emma_get_preference_fields');

    fetch(igniteJsVars.ajaxurl, {
        method: 'POST',
        body: formData,
    })
        .then((response) => response.text())
        .then((data) => {
            const response = JSON.parse(data);

            if ( response.status === 'success' ) {
                console.log(response);
                loadPreferencesForm(response.fields, userData);
            } else {
                console.log('error');
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

const loadPreferencesForm = (fields, userData) => {
    console.log(userData);
    const formData = new FormData();
    formData.append('action', 'emma_load_preferences_form');

    Object.entries(userData).forEach(([name, value]) => {
        formData.append(name, value);
    });

    fetch(igniteJsVars.ajaxurl, {
        method: 'POST',
        body: formData,
    })
        .then((response) => response.text())
        .then((data) => {
            const container = document.querySelector('.lsf__preference-center__inner');
            container.innerHTML = data;

            // Initialize the date picker after the form is loaded
            initializeDatePicker();

            // Initialize the state dropdown
            initializeStateDropdown();

            // Initialize checkbox groups
            initializeCheckboxGroup(fields, userData, 'food--drink', '.js__food-and-drink-container');
            initializeCheckboxGroup(fields, userData, 'dining-style', '.js__dining-style-container');
            initializeCheckboxGroup(fields, userData, 'opt-out', '.js__opt-out-container');

            // Initialize dropdowns
            initializeDropdown({
                fields,
                userData,
                shortcutName: 'favorite-location',
                selectId: 'lsf__preference-center-preferences-form-location'
            });

           
        })
        .catch((error) => {
            console.error(error);
        });
}

const initializeDatePicker = () => {
    const dobPickerInputs = document.querySelectorAll('.js__preference-center-date');

    dobPickerInputs.forEach((dobPickerInput) => {
        let initialDate = null;
        if (dobPickerInput.value) {
            // Try to parse the input value as a date
            const parsedDate = new Date(dobPickerInput.value);
            console.log('Parsed date:', parsedDate);
            if (!isNaN(parsedDate.getTime())) {
                // If parsing succeeds, format the date as expected by easepick
                initialDate = parsedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                console.log('Parsed initial date:', initialDate);
            }
        }
        
        const dobPicker = new easepick.create({
            element: dobPickerInput,
            css: [
                'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css',
                'https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.0/dist/index.css',
            ],
            zIndex: 10,
            format: 'MMMM DD YYYY',
            plugins: ['LockPlugin', 'AmpPlugin'],
            LockPlugin: {
                maxDate: Date.now(),
            },
            AmpPlugin: {
                darkMode: false,
                dropdown: {
                    minYear: 1900,
                    maxYear: null,
                    months: true,
                    years: true,
                },
            },
            date: initialDate,
            autoApply: false,
        });
        
        if (initialDate) {
            console.log('Input value:', dobPickerInput.value);
            // If there's a value, set the easepick date to that value
            dobPickerInput.value = initialDate;
        } else {
            console.log('No input value, setting default date');
            // If there's no value, set the default date
            dobPicker.setDate('November 01 1980');
        }
    });
}

const initializeStateDropdown = () => {
    const countryDropdown = document.querySelector('#lsf__preference-center-preferences-form-country');

    if (countryDropdown) {
        countryDropdown.addEventListener('change', (event) => {
            const country = event.target.value;
            const stateColumn = document.querySelector('.js__state-column');
            const stateDropdown = stateColumn.querySelector('#lsf__preference-center-preferences-form-state');

            if (country !== 'United States') {
                stateColumn.classList.add('d-none');
                stateDropdown.setAttribute('disabled', 'disabled');
            } else {
                stateColumn.classList.remove('d-none');
                stateDropdown.removeAttribute('disabled');
            }
        });
    }
}

const handlePreferencesFormSubmit = (event) => {
    console.log('submit');
    event.preventDefault();

    const container = event.target.closest('.lsf__preference-center__preferences-form-container');
    if (!container) {
        console.error('Preferences container not found');
        return;
    }

    const inputs = container.querySelectorAll('input, select, textarea');
    const userData = {};

    inputs.forEach(input => {
        const inputValue = !input.hasAttribute('disabled') ? input.value : '';
        
        if (input.dataset.type === 'multiple') {
            if (!userData[input.name]) {
                userData[input.name] = [];
            }
            if (input.checked) {
                userData[input.name].push(inputValue);
            }
        } else {
            if (input.type === 'checkbox' || input.type === 'radio') {
                if (input.checked) {
                    userData[input.name] = inputValue;
                }
            } else {
                userData[input.name] = inputValue;
            }
        }
    });

    console.log(userData);

    // Send data to Emma
    updateEmmaPreferences(userData);
}

const updateEmmaPreferences = (userData) => {
    const formattedData = {
        email: userData.email,
        fields: {}
    };

    // Show message container on top of the form
    showMessageContainer();

    // Add SMS field only if mobile_number exists
    if (userData.mobile_number) {
        formattedData.sms = {
            phone_number: userData.mobile_number,
        };
    }
 
    // Add status_to field only if unsubscribe-all exists, correctly formatted
    if (userData['unsubscribe-all']) {
        formattedData.status_to = userData['unsubscribe-all'] === '1' ? 'o' : 'a';
    }

    // Dynamically add all fields except 'email' 'mobile_number' and 'unsubscribe-all' to the fields object
    Object.keys(userData).forEach(key => {
        if (key !== 'email' && key !== 'mobile_number' && key !== 'unsubscribe-all') {
            formattedData.fields[key] = userData[key];
        }
    });

    console.log('Sending data to server:', formattedData);

    // Send data to Emma
    fetch(igniteJsVars.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'emma_update_preference_fields',
            field_data: JSON.stringify(formattedData)
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Server response:', data);
        let resultMessage = '';
        if (data.success) {
            resultMessage = 'Preferences updated successfully!';
        } else {
            if (data.data.error_type === 'member_not_found') {
                resultMessage = 'Error: Member not found in Emma. Please check the email address.';
            } else {
                console.error('Error updating preferences:', data.data.error_type, data.data.response);
                resultMessage = 'Error updating preferences' + data.data.response.error + '. Please try again.';
            }
        }

        // Show result message
        showResultMessage(resultMessage);
    })
    .catch(error => {
        console.error('Error:', error);
        // Show result message
        showResultMessage('An error occurred. Please try again.');
    });
}

const showMessageContainer = () => {
    const messageContainer = document.querySelector('.lsf__preference-center__message');
    messageContainer.classList.add('visible');
}

const hideMessageContainer = () => {
    const messageContainer = document.querySelector('.lsf__preference-center__message');
    messageContainer.classList.remove('visible');
    hideResultMessage();
}

const showResultMessage = (resultMessage) => {
    const messageBox = document.querySelector('#lsf__preference-center__message-content');
    const messageText = messageBox.querySelector('.lsf__preference-center__message-text');
    messageText.textContent = resultMessage;
    messageBox.classList.add('visible');

    //scroll the page to the center of the message box
    const messageBoxRect = messageBox.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const centerY = messageBoxRect.top + scrollTop - (messageBoxRect.height / 2);
    window.scrollTo({ top: centerY, behavior: 'smooth' });
}

const hideResultMessage = () => {
    const messageBox = document.querySelector('#lsf__preference-center__message-content');
    messageBox.classList.remove('visible');
}

const initializeCheckboxGroup = (fields, userData, shortcutName, containerClass) => {
    // Find the field in the fields data
    const field = fields.find(field => field.shortcut_name === shortcutName);
    if (!field || !field.options) return;

    // Get the stored values from userData if it exists
    const storedValues = userData[shortcutName] || [];

    // Create the checkbox group container
    const checkboxGroup = document.createElement('div');
    checkboxGroup.className = 'lsf__preference-center__preferences-form-elem';

    // Create each checkbox from the field options
    field.options.forEach(value => {
        const checkboxItem = document.createElement('div');
        checkboxItem.className = 'lsf__preference-center__checkbox-item';

        const sanitizedValue = value.toLowerCase().replace(/\s+/g, '-');
        const inputId = `${shortcutName}_${sanitizedValue}`;

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.id = inputId;
        input.name = shortcutName;
        input.value = value;
        input.dataset.type = 'multiple';
        input.checked = storedValues.includes(value);

        const label = document.createElement('label');
        label.htmlFor = inputId;
        label.className = 'f__link-serif u__c-brown lsf__preference-center__input-checkbox-label';
        label.textContent = value;

        checkboxItem.appendChild(input);
        checkboxItem.appendChild(label);
        checkboxGroup.appendChild(checkboxItem);
    });

    // Find the container and insert the checkboxes
    const targetContainer = document.querySelector(containerClass);
    if (targetContainer) {
        targetContainer.innerHTML = ''; // Clear existing content
        targetContainer.appendChild(checkboxGroup);
    }
}

const initializeDropdown = ({
    fields,
    userData,
    shortcutName,
    selectId
}) => {
    // Find the select element
    const select = document.getElementById(selectId);
    if (!select) return;

    // Get the stored value from userData
    const storedValue = userData[shortcutName] || '';

    // Find the field in the fields data
    const field = fields.find(field => field.shortcut_name === shortcutName);
    if (field && field.options) {
        // Clear existing options except the first one
        while (select.options.length > 1) {
            select.remove(1);
        }

        // Add new options
        field.options.forEach(option => {
            const optionElement = document.createElement('option');
            optionElement.value = option;
            optionElement.textContent = option;
            optionElement.selected = storedValue === option;
            select.appendChild(optionElement);
        });
    }
}